import Slider from '@ui/Slider/component'

export default (rootEl: HTMLElement): void => {
  if (!rootEl) {
    return
  }

  const sliderEl = rootEl.querySelector<HTMLElement>('.slider')

  if (!sliderEl) {
    return
  }

  Slider(sliderEl, {
    navigation: {
      prevEl: rootEl.querySelector<HTMLElement>('.slider-navigation [data-direction="left"]'),
      nextEl: rootEl.querySelector<HTMLElement>('.slider-navigation [data-direction="right"]'),
    },
    loop: true,
    spaceBetween: 24,
    pagination: {
      el: rootEl.querySelector<HTMLElement>('.slider-pagination') ?? null,
    },
  })
}
